import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';

var IconCopy = function IconCopy(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-copy",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M458.3 416.7H208.3A125.4 125.4 0 0 0 83.3 541.7V791.7A125.4 125.4 0 0 0 208.3 916.7H458.3A125.4 125.4 0 0 0 583.3 791.7V541.7A125.4 125.4 0 0 0 458.3 416.7ZM541.7 791.7A83.3 83.3 0 0 1 458.3 875H208.3A83.3 83.3 0 0 1 125 791.7V541.7A83.3 83.3 0 0 1 208.3 458.3H458.3A83.3 83.3 0 0 1 541.7 541.7ZM916.7 208.3V458.3A125.4 125.4 0 0 1 791.7 583.3H625V541.7H791.7A83.3 83.3 0 0 0 875 458.3V208.3A83.3 83.3 0 0 0 791.7 125H541.7A83.3 83.3 0 0 0 458.3 208.3V375H416.7V208.3A125.4 125.4 0 0 1 541.7 83.3H791.7A125.4 125.4 0 0 1 916.7 208.3Z"
  }));
};
IconCopy.defaultProps = {
  title: 'copy'
};
IconCopy.propTypes = {
  title: PropTypes.string
};

export { IconCopy };
